import {Toast} from 'antd-mobile'
import Header from "@/components/header";
import React, {useEffect, useRef, useState} from 'react'
import Footer from "@/components/Footer";

const Nave = () => {
    useEffect(() => {
        // 1. 创建 script 标签
        const script = document.createElement('script');
        script.src = 'https://nnbnnj0vnrfxfmnozq.mwkqm.cn/embed.js';

        // 设置自定义 data-* 属性
        script.setAttribute('data-render', 'page');
        script.setAttribute('data-channel', 'sm');
        script.async = true; // 异步加载，不阻塞渲染

        // 2. 将标签挂载到 body 中
        document.body.appendChild(script);

        // 3. 卸载钩子（Cleanup）：当组件销毁时删除该标签，保持 DOM 干净
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);
    return (
        <div className="arrdv9-0 kaxIlA">
            <Header></Header>
            <div id="navhub-root"></div>
            <Footer></Footer>
        </div>
    )
}

export default Nave
